export const uploadMethod = {
  methods: {
    onUploadError (file) {
      // code removed as handle httpError Globally
    }
  }
}
